// @flow
import withFormValidation from '../with_form_validation'
import TextInput from './TextInput'

export default withFormValidation(TextInput)
